import type { Theme } from '@mui/material';
// import type { Components } from '@mui/material/styles';

export default function MUIDrawer(theme: Theme) /* : Components['MuiDrawer'] */ {
  return {
    // defaultProps: {},
    styleOverrides: {
      root: {
        zIndex: theme.zIndex.drawer,
      },
    },
    // variants: [],
  };
}
